module.exports = __webpack_public_path__ + "img/Bjd1.7ef01c12.jpg";